<template>
  <div>
    <div class="border-box"></div>
    <div class="header" :class="{ hidden: isHeaderHidden }">
      <!-- <div class="maintitle">マップデザインAI</div> -->
      <img class="header-img" src="@/assets/title/logo_designmapai.png" />
      <div class="subtitle">オリジナル地図作りが、もっと身近に。</div>
      <button @click="navigateToTop">オリジナルの地図を作成</button>
      <div class="title-note">※本サービスはPCブラウザのみ対応しています。</div>
    </div>
    <div class="container">
      <div class="parallax">
        <div class="circle color-blue" ref="blueCircle">
          <img src="@/assets/title/illust_01.png" alt="Blue Circle" class="circle-img" style="width: auto; height: 240px; margin-right: 40px; margin-left: auto; margin-bottom: -30px;" />
          <div class="text color-blue" ref="blueText">
            <div class="ttl">広がる地図で、<br />街全体を楽しむ案内を</div>
            <div class="subtext">地図で街歩きや祭りを特別な体験に変えます</div>
          </div>
        </div>
        <div class="circle color-green" ref="greenCircle">
          <img src="@/assets/title/illust_02.png" alt="Green Circle" class="circle-img" style="width: auto; height: 210px; margin-right: auto; margin-left: 20px;" />
          <div class="text color-green" ref="greenText">
            <div class="ttl">推し色マップで応援！</div>
            <div class="subtext">特別感あるマップでイベント成功の第一歩に</div>
          </div>
        </div>
        <div class="circle color-orange" ref="orangeCircle">
          <img src="@/assets/title/illust_03.png" alt="Orange Circle" class="circle-img" style="width: auto; height: 200px; margin-right: 60px; margin-left: auto; margin-top: 15px;" />
          <div class="text color-orange" ref="orangeText">
            <div class="ttl">あなたのお店らしさを<br />地図にもプラス</div>
            <div class="subtext">店舗案内をオリジナル地図でもっと魅力的に！</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="copyright">Copyright(C) 2003-2025 ZENRIN DataCom CO.,LTD.</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isHeaderHidden: false,
      headerTimer: null,
      blueCircleTimer: null,
      blueTextTimer: null,
      greenCircleTimer: null,
      greenTextTimer: null,
      orangeCircleTimer: null,
      orangeTextTimer: null
    }
  },

  mounted () {
    this.headerTimer = setTimeout(() => {
      this.isHeaderHidden = true
      this.blueCircleTimer = setTimeout(() => {
        this.$refs.blueCircle.style.opacity = 1
        this.blueTextTimer = setTimeout(() => {
          this.$refs.blueText.style.opacity = 1
        }, 500)
        this.greenCircleTimer = setTimeout(() => {
          this.$refs.greenCircle.style.opacity = 1
          this.greenTextTimer = setTimeout(() => {
            this.$refs.greenText.style.opacity = 1
          }, 500)
          this.orangeCircleTimer = setTimeout(() => {
            this.$refs.orangeCircle.style.opacity = 1
            this.orangeTextTimer = setTimeout(() => {
              this.$refs.orangeText.style.opacity = 1
            }, 500)
          }, 1000)
        }, 1000)
      }, 1000)
    }, 1000)
  },

  beforeDestroy () {
    clearTimeout(this.headerTimer)
    clearTimeout(this.blueCircleTimer)
    clearTimeout(this.blueTextTimer)
    clearTimeout(this.greenCircleTimer)
    clearTimeout(this.greenTextTimer)
    clearTimeout(this.orangeCircleTimer)
    clearTimeout(this.orangeTextTimer)
  },

  methods: {
    navigateToTop () {
      this.$router.push('/top')
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  overflow-x: hidden;
  background-color: #f4f4f4;
}

.container {
  position: relative;
  height: 100vh;
  padding: 50px;
}

.header {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
  transition: top 1s ease-in-out;
  z-index: 20;
  overflow-x: hidden;
}

.header.hidden {
  top: 180px;
}

.header-img {
  width: 90%;
  max-width: 390px;
  height: auto;
}

.maintitle {
  font-size: 46px;
  font-weight: bold;
  color: #2B48A8;
}

.subtitle {
  font-size: 20px;
  font-weight: bold;
  color: #1B466D;
  margin-top: 10px;
}

button {
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  width: 240px;
  padding: 15px;
  margin-top: 30px;
  background-color: #6D87C1;
  border: none;
  border-radius: 50px;
  cursor: pointer;
}

.title-note {
  font-size: 9px;
  padding-top: 5px;
}

.parallax {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  top: 0;
  left: 0;
  overflow: hidden;
}

.circle {
  position: absolute;
  width: 380px;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

@keyframes floatBlue {
  0% {
    transform: translate(-50%, -50%) translateY(0);
  }

  50% {
    transform: translate(-50%, -50%) translateY(-20px);
  }

  100% {
    transform: translate(-50%, -50%) translateY(0);
  }
}

@keyframes floatGreen {
  0% {
    transform: translate(-50%, -50%) translateY(0);
  }

  50% {
    transform: translate(-50%, -50%) translateY(-15px);
  }

  100% {
    transform: translate(-50%, -50%) translateY(0);
  }
}

@keyframes floatOrange {
  0% {
    transform: translate(-50%, -50%) translateY(0);
  }

  50% {
    transform: translate(-50%, -50%) translateY(-10px);
  }

  100% {
    transform: translate(-50%, -50%) translateY(0);
  }
}

.circle.color-blue {
  background-image: url(../assets/title/top_BG_01.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  top: 30vh;
  left: calc(83% - 50px);
  animation: floatBlue 4s ease-in-out infinite;
}

.circle.color-green {
  background-image: url(../assets/title/top_BG_02.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  top: 42vh;
  left: calc(17% + 50px);
  animation: floatGreen 4s ease-in-out infinite;
}

.circle.color-orange {
  width: 400px;
  background-image: url(../assets/title/top_BG_03.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  top: 60vh;
  left: calc(46% + 50px);
  animation: floatOrange 4s ease-in-out infinite;
}

.text {
  position: relative;
  font-size: 26px;
  font-weight: bold;
  margin-top: 15px;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.text.color-green {
  padding-left: 10px;
}

.text.color-orange {
  padding-left: 30px;
}

.text.color-blue .ttl {
  color: #1B466D;
}

.text.color-green .ttl {
  color: #0E784A;
}

.text.color-orange .ttl {
  color: #994949;
}

.text .subtext {
  font-size: 14px;
  margin-top: 10px;
}

.square {
  position: absolute;
  width: 100px;
  height: 100px;
  top: -120px;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.square.color-blue {
  top: -110px;
}

.square.color-green {
  top: -80px;
}

.square.color-orange {
  top: -50px;
}

.border-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  border: 50px solid #E2DADA;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 10;
}

.footer {
  position: fixed;
  bottom: 10px;
  right: 10px;
  text-align: right;
  transition: top 1s ease-in-out;
  z-index: 20;
}

.footer .copyright {
  font-size: 10px;
  color: #322C2C;
}
</style>
